import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { RestServices } from '@services/rest.services'
import { AuthService } from '@services/auth.services'
import { ToastrService } from 'ngx-toastr'
import { RequestServices } from '@services/request.services'
import MainConfig from '../../config/main'
import { environment } from '../../environments/environment'

export const senderID = environment.senderID
declare var PushNotification: any

@Injectable()
export class NotificationService {

    public enable: boolean = false

    public pushNotification: any

    public getNotification$: BehaviorSubject<INotification> = new BehaviorSubject<INotification>(null)

    private ANDROID_SETTING = {
        senderID,
        // icon: '',
        // iconColor: '',
        alert: true,
        badge: true,
        sound: true,
        clearNotifications: true,
    }
    private IOS_SETTING = {
        senderID,
        // icon: '',
        // iconColor: '',
        alert: true,
        badge: true,
        sound: true,
    }
    private enableWebsocket: boolean

    constructor(private restApi: RestServices,
                private authData: AuthService,
                private toastr: ToastrService,
                private requestService: RequestServices,
    ) {
        this.enableWebsocket = MainConfig.ENABLE_WEBSOCKET
        if (typeof PushNotification != 'undefined') {
                    this.enable = true
                    this.pushNotification = PushNotification.init({
                        android: this.ANDROID_SETTING,
                        ios: this.IOS_SETTING,
                    })
            this.pushNotification.on('registration', data => {
                localStorage.setItem('device_token', data.registrationId)
             })
        }
    }

    /**
     * If successfully, return device token
     */
    registerNotification(): Observable<IDeviceToken> {
        this.pushNotification = PushNotification.init({
            android: this.ANDROID_SETTING,
            ios: this.IOS_SETTING,
        })
        return new Observable(subscriber => {
            if (!this.enable) {
                subscriber.error(`Can't use push notification`)
            } else {
                this.pushNotification.on('registration', data => {
                    console.log('registration', data)
                    localStorage.setItem('device_token', data.registrationId)
                    subscriber.next({
                        deviceToken: data.registrationId,
                        type: data.registrationType,
                    })
                })
                this.pushNotification.on('error', e => {
                    console.log('error', e)
                    subscriber.error(e)
                })
            }
        })
    }

    listenNotification() {
        if (this.enable) {
            console.log('listenNotification')
            this.pushNotification.on('notification', data => {
                console.log(data)
                if (data.additionalData) {
                    const pushData: INotification = {
                        title: data.title,
                        message: data.message,
                        count: data.count,
                        sound: data.sound,
                        image: data.image,
                        additionalData: data.additionalData,
                    }
                    console.log('PushNotification subscribe')
                    console.log(this.pushNotification, 'PushNotification subscribe')
                    this.setApplicationIconBadgeNumber(pushData.count || 0)
                    this.getNotification$.next(pushData)
                }
            })
        }
    }

    setApplicationIconBadgeNumber(number = 1) {
        if (this.enable) {
            this.getApplicationIconBadgeNumber().subscribe(currentNumber => {
                this.pushNotification.setApplicationIconBadgeNumber(
                    () => {
                        console.log('success', currentNumber + number, currentNumber, number)
                    },
                    () => {
                        console.log('error')
                    },
                    currentNumber + number,
                )
            })
        }
    }

    getApplicationIconBadgeNumber(): Observable<number> {
        return new Observable(subscriber => {
            if (this.enable) {
                return this.pushNotification.getApplicationIconBadgeNumber(
                    n => {
                        subscriber.next(n)
                    },
                    () => {
                        subscriber.next(0)
                    },
                )
            }
            subscriber.next(0)
        })
    }

    clearAllNotifications() {
        if (this.enable) {
            this.pushNotification.clearAllNotifications(
                () => {
                    console.log('clearAllNotifications success')
                },
                () => {
                    console.log('clearAllNotifications error')
                },
            )
        }
    }

    performPushNotification(clientId) {
        if (this.enableWebsocket) {
            this.requestService.httpPost('websocket/push-notification', { clientId }).subscribe(res => {
                console.log(res)
            })
        }
    }

}

interface IDeviceToken {
    // FCM | APNS
    type: string;
    // device token
    deviceToken: string;
}

interface INotification {
    message?: string;
    title?: string;
    count?: number;
    sound?: boolean;
    image?: string;
    additionalData?: any;
}



// WEBPACK FOOTER //
// ./src/app/services/notification.service.ts